var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"fixed":"","dense":"","color":"grey4"}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.showDrawer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }